<template>
  <div class="container mainContent">
    <div class="card mb-3">
      <div class="card-header text-left">
        <div class="row">
          <div class="col-12">
            <h4>หมายเลขผู้ลงทะเบียน {{ this.getUsername() }} </h4>
          </div>
          <div class="col-12">
            <h4>ชื่อ : {{ this.getName() }} นามสกุล : {{ this.getSurname() }} </h4>
          </div>
          <div class="col-12 Aligner">
            <b-card
              :img-src="qrcode"
              img-alt="QR Code"
              style="max-width: 150px;"
              class=""
            ></b-card>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col text-left">
        <h4 class="mb-3">กิจกรรมที่คุณลงทะเบียน</h4>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th scope="col">ชื่อกิจกรรม</th>
            <th class="description" scope="col" style="width:35%;">รายละเอียด</th>
            <th scope="col">สถานที่</th>
            <th scope="col">วันที่</th>
            <th scope="col">เวลา</th>
            <th scope="col">สถานะ</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="value in table_Compronent" v-bind:key="value.id">
              <td scope="col"> {{ value.name }} </td>
              <td class="description" scope="col"> {{ value.description }} </td>
              <td scope="col"> {{ value.place }} </td>
              <td scope="col"> {{ value.date +" สิงหาคม 2562"}} </td>
              <td scope="col"> {{ value.time }} </td>
              <td scope="col" v-if="value.isAttend"> เข้าร่วมกิจกรรมเเล้ว </td>
              <td scope="col" v-if="!value.isAttend"> ยังไม่ได้เข้าร่วมกิจกรรม </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-12">
        <a class="btn btn-primary w-100" style="cursor:pointer" @click="gotoWorkshop()">สมัครกิจกรรมเพิ่มเติม</a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import { mapGetters } from 'vuex';
import QRcode from "qrcode";
import axios from 'axios';

Vue.use(BootstrapVue)
export default {
  name: 'Dashboard',
  data: () => {
    return {
      username: "Guest",
      name: "",
      surname: "",
      school: "",
      token: "",
      qrcode: "",
      table_Compronent: null
    }
  },
  methods: {
    ...mapGetters([
      'getUsername', 
      'getPassword',
      'getName',
      'getSurname',
      'getLoginState',
      'getToken'
    ]),
    getUserProfile() {
      this.username = this.getUsername()
    },
    gotoWorkshop() {
      this.$router.push('/workshop')
    },
    onLoad() {
      this.username = this.getUsername()
      this.password = this.getPassword()
      let hostname = "https://oph2019-kmitl-c2dac.firebaseapp.com"
      QRcode.toDataURL(`${hostname}/profile?user=${this.username}&password=${this.password}`)
      .then(url => {
        this.qrcode = url;
      })
      .catch(err => {
      });
    },
    getEvent() {
      axios({
        method: "GET",
          url: "https://us-central1-oph2019-kmitl-c2dac.cloudfunctions.net/user/getUserByID",
          headers: {
            "id": this.getUsername()
          }
      })
      .then((res) => {
        // console.log(res.data.registeredEvent)
        this.table_Compronent = res.data.registeredEvent
      })
      .catch((err) => {
        console.log(err)
      })
    }
  },
  mounted() {
    if (this.getLoginState() === false) this.$router.replace('/login')
    else this.getUserProfile()
    this.onLoad()
    this.getEvent()
  },
}
</script>

<style lang="scss" scoped>
.card-body {
  display: none;
}

td, th {
    text-align: justify;
}

.Aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}

#table-container {
  overflow-x: auto;
}

.btn-primary {
  color: #fff;
  background-color: #ee4b23;
  border-color: #ee4b23;
}

a:not([href]):not([tabindex]):focus, a:not([href]):not([tabindex]):hover {
  color: rgba(255,255,255,.5);
  text-decoration: none;
  background-color: #ee4b23;
  border-color: #ee4b23;
}

a:not([href]):not([tabindex]) {
  color: #fff;
  text-decoration: none;
}

.mainContent {
  min-height: calc(100vh - 314px) ;
}

@media screen and (max-width: 568px) {
	.description {
    display: none;
  }
}
</style>
